import { gql } from 'apollo-boost';

export const fragments = {

	DATA_VALUE_SETS: {
		QUERY_RETURN: `id name`
	},

	DATA_VALUE_SET: {
        QUERY_RETURN: `id name items{ id ordinal value } valueType refIdCode`,
        MUTATION_RETURN: `id name items{ id ordinal value } valueType refIdCode`,
		EDIT_FIELDS: `id name items{ id ordinal value } valueType refIdCode`,
	}

};

export const queries = {

	/* DATA VALUE SETS
	* --------------------------------------------------------------------------------------------*/
	GET_DATA_VALUE_SETS: ( returnQueryString = fragments.DATA_VALUE_SETS.QUERY_RETURN ) => gql`
	  query GetDataValueSets {
		dataValueSets {
			${ returnQueryString }
		}
	  }`,

	GET_DATA_VALUE_SET: ( returnQueryString = fragments.DATA_VALUE_SET.QUERY_RETURN ) => gql`
	  query GetDataValueSet( $id: Uuid! ){
	    dataValueSet( id: $id ) {
	        ${ returnQueryString }
	    }
	  }`,
};

export const mutations = {

	CREATE_DATA_VALUES_SET: ( returnQueryString = fragments.DATA_VALUE_SET.MUTATION_RETURN ) => gql`
	  mutation CreateDataValueSet( $input: DataValueSetCreateCommandInput! ){
	    createDataValueSet( input: $input ) {
	        ${ returnQueryString }
	    }
	  }`,

	UPDATE_DATA_VALUES_SET: ( returnQueryString = fragments.DATA_VALUE_SET.MUTATION_RETURN ) => gql`
	  mutation UpdateDataValueSet( $input: DataValueSetUpdateCommandInput! ){
	    updateDataValueSet( input: $input ) {
	        ${ returnQueryString }
	    }
	  }`,

	DELETE_DATA_VALUES_SET: () => gql`
	  mutation DeleteDataValueSet( $input: DataValueSetDeleteCommandInput! ){
	    deleteDataValueSet( input: $input )
	  }`,
};

export const functions = {}

export const DataValueSetQueries = {
	fragments,
	queries,
	mutations,
	functions,
};
